import { useMemo } from 'react';

export const useHighlightRemaining = (input: string, fullWord: string) => useMemo(() => {
	const inputLength = input.length;
	const entered = fullWord.slice(0, inputLength);
	const remaining = fullWord.slice(inputLength);

	return (
		<>
			{entered}
			<strong>{remaining}</strong>
		</>
	);
}, [input, fullWord]);
